import styled from "styled-components";
import { rem } from "../../helpers/rem/px-to-rem";

export const RowDataWrapper = styled.div`
  background-size: cover;
  width: 96%;
  overflow: auto;
  padding: ${rem(20)};
  margin: ${rem(20)};
  font-size: ${rem(20)};
  .table-row-data {
    .ant-pagination-options {
      display: none;
    }
    margin-right: ${rem(20)};
    .ant-table-pagination.ant-pagination {
      width: 100%;
      display: flex;
      justify-content: start;
    }
    .ant-table-row {
      background-color: white;
    }
    .ant-table-thead > tr > th {
      background: #0089cf;
      color: white;
    }
    thead > tr > th {
      border-bottom: 0.5px solid #dfe4ea;
    }
    .ant-table-thead {
      border: none;
      background-color: #0089cf;
    }
    table thead {
      background-color: #0089cf;
      border-bottom: 0.5px solid #dfe4ea;
    }
    table tr td {
      border-right: none;
      border-bottom: 0.5px solid #dfe4ea;
    }
    table tr td:nth-child(1) {
      border-left: none;
    }
  }
  .visible {
    table {
      visibility: hidden;
    }
  }
`;
